import { FC, ReactNode } from 'react';

import PageHeader, { IPageHeader } from '../PageHeader';
import classes from './styles.module.scss';

interface IPageLayout {
  children: ReactNode[] | ReactNode;
  titleProps: IPageHeader;
  className?: string;
}

const PageLayout: FC<IPageLayout> = ({
  children,
  titleProps,
  className = ''
}) => {
  return (
    <div className={className}>
      <PageHeader {...titleProps} />
      <div className={classes.content}>
        {Array.isArray(children) ? (
          children?.map((child, index) => <div key={index}>{child}</div>)
        ) : (
          <div>{children}</div>
        )}
      </div>
    </div>
  );
};

export default PageLayout;
